'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import report, { ReportEvent } from '@/lib/report';

/**
 * Push 通知点击追踪组件
 *
 * 检测 URL 中的 from=push 参数,上报用户通过 push 通知返回的事件
 */
export default function PushNotificationTracker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    const from = searchParams.get('from');

    if (from === 'push') {
      // 上报 push 通知点击事件
      report(ReportEvent.PUSH_NOTIFICATION_CLICKED, {
        timestamp: Date.now(),
        url: window.location.href,
      });

      console.log('[PushNotificationTracker] User returned from push notification');
    }
  }, [searchParams]);

  return null;
}
